import { unsupported } from '../errors'
import type { PeticionesService } from './types'

/**
 * La API actual no tiene peticiones (inventario §2.2, 8.8) y el PMS no las recibe como tareas con estado (D48).
 * Sin datos de ejemplo en una reserva real (D36): `not_supported`, y la pantalla ofrece WhatsApp con la referencia.
 */

export const peticionesReal: PeticionesService = {
  list: unsupported,
  get: unsupported,
  create: unsupported,
  addComment: unsupported,
}
